import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { opt, i18n, DateFormatter } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';


class IntermediariTable extends React.Component {
    constructor(props) {
        super(props);
        // this.detailsOnClick = this.detailsOnClick.bind(this);
        this.componentName = '[IntermediariTable.jsx] ';
        const cellEdit = {
            "mode": "click",
            blurToSave: true
        }
        this.state = {
            indexIntermediario: null,
            intermediarioDaModificare: null,
            wasSelected: false
        }
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.columnEdit = this.columnEdit.bind(this);
        this.annullaOnClick = this.annullaOnClick.bind(this);
        this.closeOnClick = this.closeOnClick.bind(this);
        this.aggiornaIntermediari = this.aggiornaIntermediari.bind(this);
        // this.aggiungiGaranziaOnClick = this.aggiungiGaranziaOnClick.bind(this);
        this.salvaOnClick = this.salvaOnClick.bind(this)
        this.checkBoxChangeHandler = this.checkBoxChangeHandler.bind(this)
    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [];
        if (this.props.source && this.props.source === "prodottoCreate") {
            columns = [
                { checkbox: true, field: "selezionato", visible: this.props.source && this.props.source === "prodottoCreate" },
                { field: 'idIntermedioario', title: 'Id', sortable: 'true' },
                { field: 'intermediario.denominazione', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMEDIARIO', 'Intermediario'), sortable: 'true' },
                // { field: 'selezionato', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.ASSOCIAZIONE', 'Associazione'), sortable: 'true', formatter: this.associazioneFormatter, visible: this.props.source && this.props.source === "prodottoDetails" },

                { field: 'edit', title: i18n('ARM_CORE_PRODUCT.MODIFICA','Modifica'), formatter: this.columnEdit },
                // {
                //     field: 'prodottoIntermediario.numProposte', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.PROPOSTE', 'Proposte'), sortable: 'true',
                //     //     editor: {
                //     //         type: "text"
                //     //     }
                //     // }
                //     // dataField: 'prodottoIntermediario.numProposte', dataFormat: this.inputFormatter
                //     mode: "click", blurToSave: true, formatter: this.inputFormatter, onChange: this.changevalue
                // },

                // { field: 'prodottoIntermediario.numEmissioni', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.EMISSIONI','Emissioni'), sortable: 'true', },
            ]
        } else {

            columns = [
                { field: 'idIntermedioario', title: 'Id', sortable: 'true' },
                { field: 'intermediario.denominazione', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMEDIARIO', 'Intermediario'), sortable: 'true' },
                { field: 'selezionato', textAlign: 'center', dataAlign: 'center', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.ASSOCIAZIONE', 'Associazione'), sortable: 'true', formatter: this.associazioneFormatter, visible: this.props.source && this.props.source === "prodottoDetails" },
                { field: 'scontoDiscMin', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.SCONTO_DISC_MAX', 'Sconto Discrezionale Min'), sortable: 'true', visible: this.props.source && this.props.source === "prodottoDetails" },
                { field: 'scontoDiscMax', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.SCONTO_DISC_MIN', 'Sconto Discrezionale Max'), sortable: 'true', visible: this.props.source && this.props.source === "prodottoDetails" },
                { field: 'visDocPolizza', textAlign: 'center', dataAlign: 'center', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.VISDOCPOLIZZA', 'Visualizza Documento Polizza'), sortable: 'true', formatter: this.associazioneFormatterDoc, visible: this.props.source && this.props.source === "prodottoDetails" && opt("APP", "FL_VIEW_CHECKBOX_TAB_INTERMEDIARI", "false") === "true" },
                { field: 'abilitaEmissione', textAlign: 'center', dataAlign: 'center', title: i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMED.EMISSIONE', 'Emissione'), sortable: 'true', formatter: this.associazioneFormatterEm, visible: this.props.source && this.props.source === "prodottoDetails" && opt("APP", "FL_VIEW_CHECKBOX_EMISSIONE", "false") === "true" },
                // { field: 'edit', title: 'Modifica', formatter: this.columnEdit },
                // { field: 'edit', title: 'Modifica', formatter: this.columnEdit },
            ]
        }
        //     columns = [
        //         { checkbox: true, field: "selezionato", visible: this.props.useCheckBox },
        //     { field: 'intermediario.id', title: 'Id', sortable: 'true' },
        //     { field: 'intermediario.denominazione', title: 'Intermediario', sortable: 'true' },
        //     { field: 'prodottoIntermediarioPojo.selezionato', title: 'Associazione', sortable: 'true', formatter: this.associazioneFormatter },
        //     { field: 'prodottoIntermediario.numProposte', title: 'Proposte', sortable: 'true', },
        //     { field: 'prodottoIntermediario.numEmissioni', title: 'Emissioni', sortable: 'true', },
        //     // { field: 'insertDate', title: 'Data Inserimento', formatter: this.dateFormatter, sortable: 'true' },
        //     // { field: 'info', title: '', formatter: this.columnEdit },
        // ];
        // }

        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "idIntermedioario",
            sortable: true,
            search: true,
            showColumns: true,
            sortOrder: "desc",
            // pagination: true,
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            // maxHeight: "150px",
            scroll: true,

            height: "450",
            overflow: "auto",
            display: "inline-block",
            // dataMaintainSelected:true,
            // sidePagination: "server",


            onClickRow: (row, $element, field) => this.editOnClick(row, $element, field),
            // sortOrder: "desc",


        });

        if (this.props.rows !== null && this.props.rows !== undefined) {

            $(this.refs.MyTable).bootstrapTable('load', this.props.rows);
        }
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }
    associazioneFormatter(value, row, index) {
        if (value !== undefined && value !== null) {
            if (value) {
                //<i className="fas fa-info-circle" title={val} ></i>
                //"<button class='btn btn-info btn-sm'><i class='fas fa-mouse-pointer'></i></button>";
                return "<i class='fas fa-check' ></i>";
                // return "SI";
            }
            //return "NO";
            return " ";
        }

        return '-';
    }

    associazioneFormatterDoc(value, row, index) {
        if (row !== undefined && row !== null) {
            if (row.prodottoIntermediario?.visDocPolizza) {
                //<i className="fas fa-info-circle" title={val} ></i>
                //"<button class='btn btn-info btn-sm'><i class='fas fa-mouse-pointer'></i></button>";
                return "<i class='fas fa-check' ></i>";
                // return "SI";
            }
            //return "NO";
            return "-";
        }

        return '-';
    }

    associazioneFormatterEm(value, row, index) {
        if (row !== undefined && row !== null) {
            if (row.prodottoIntermediario?.abilitaEmissione) {
                //<i className="fas fa-info-circle" title={val} ></i>
                //"<button class='btn btn-info btn-sm'><i class='fas fa-mouse-pointer'></i></button>";
                return "<i class='fas fa-check' ></i>";
                // return "SI";
            }
            //return "NO";
            return "-";
        }

        return '-';
    }


    aggiornaIntermediari() {

        console.log(this.componentName + " aggiornaIntermediari: ");

        this.props.aggiornaIntermediari().then(

            resolve => {
                this.props.getProdottoDetails(this.props.prodotto.id);
            }
        )
    }

    editOnClick(row, $element, field) {
        console.log(this.componentName + " editOnClick: " + row.id);
        if (field === "edit") {

            let indexIntermediario = this.props.rows.findIndex(currRow => currRow === row);

            let wasSelected = row.selezionato;

            let intermediarioDaModificare = JSON.parse(JSON.stringify(row));
            this.setState({ intermediarioDaModificare: intermediarioDaModificare, indexIntermediario: indexIntermediario, wasSelected: wasSelected })

            if (row.prodottoIntermediario === undefined) {
                this.props.inizializzaNuovoProdottoIntermediario(indexIntermediario).then(
                    resolve => {
                        intermediarioDaModificare = JSON.parse(JSON.stringify(this.props.rows[indexIntermediario]));
                        this.setState({ intermediarioDaModificare: intermediarioDaModificare, indexIntermediario: indexIntermediario })
                    }
                )
            }
            this.showConfirmPanel();
        }
    }

    columnEdit(value, row, index) {
        //console.log("columnEdit:" + index);
        let temp = "-";

        // if (row.selezionato) {
        temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-edit'></i></button>";
        // }
        return temp;
    }

    inputFormatter(value, row, index) {
        //console.log("columnEdit:" + index);
        let temp;
        temp = "<input type='text' onChange = 'this.changevalue()' value =" + value + "/>";
        return temp;
    }

    changevalue(e) {

        let id = e.target.id;
    }
    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({ pathname: '/garanzie/details', state: { id: row.id } });
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps?.rows !== null ? nextProps?.rows?.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }
    inputChangeHandler(e) {
        console.log(this.componentName + " inputChangeHandler");
        if (e !== null && e !== undefined) {

            let value = e.target.value;
            let id = e.target.id;
            let type = e.target.type;
            let name = e.target.name;

            let index = id.replace(name, "");

            if (type === "number" && value === "") {
                value = null;
            }


            // this.props.inputChangeHandler(index, name, value);

            let object = this.state.intermediarioDaModificare;
            object.prodottoIntermediario[name] = value;
            this.setState({ intermediarioDaModificare: object });
            // .then(
            // resolve => {
            // this.forceUpdate();
            // }
            // )
        }
    }

    annullaOnClick() {
        let indexIntermediario = this.state.indexIntermediario;
        // let names = ['scontoDiscMin', 'scontoDiscMax'];

        // names.forEach(name => {
        //     this.props.inputChangeHandler(indexIntermediario, name, null);
        // });

        this.props.resetSelected(indexIntermediario, this.state.wasSelected);

        this.setState({ indexIntermediario: null, intermediarioDaModificare: null, wasSelected: false })
        this.showConfirmPanel();
    }

    closeOnClick() {
        let indexIntermediario = this.state.indexIntermediario;

        this.props.resetSelected(indexIntermediario, this.state.wasSelected);

        this.setState({ indexIntermediario: null, intermediarioDaModificare: null, wasSelected: false })
        this.showConfirmPanel();
    }

    showConfirmPanel() {
        console.log(this.componentName + 'showConfirmPanel [showConfirm] ');
        this.props.showPopUP(!this.props.showConfirm);
    }

    salvaOnClick() {
        console.log(this.componentName + 'showConfirmPanel [showConfirm] ');
        let indexIntermediario = this.state.indexIntermediario;

        let names = ['scontoDiscMin', 'scontoDiscMax', 'visDocPolizza','abilitaEmissione'];

        names.forEach(name => {
            this.props.inputChangeHandler(indexIntermediario, name,
                this.state.intermediarioDaModificare.prodottoIntermediario[name]);
        });

        this.props.resetSelected(indexIntermediario, this.state.wasSelected);
        this.props.showPopUP(!this.props.showConfirm);
    }

    checkBoxChangeHandler(e) {
        if (e !== null && e !== undefined) {
            console.log(this.componentName + 'checkBoxChangeHandler');
            let value = e.target.value;
            let id = e.target.id;
            let name = e.target.name;
            value = true;
            if (name == 'visDocPolizza') {
                if (this.state.intermediarioDaModificare?.prodottoIntermediario?.visDocPolizza) {
                    value = false;
                }
            } else {
                if (this.state.intermediarioDaModificare?.prodottoIntermediario?.abilitaEmissione) {
                    value = false;
                }
            }


            let object = this.state.intermediarioDaModificare;
            object.prodottoIntermediario[name] = value;
            this.setState({ intermediarioDaModificare: object });
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (

            <div className="card">
                <div className="card-header">
                    <agui.aButton bs="primary" className="float-right " title="Aggiorna gli intermediari, aggiungendo i nuovi produttori " icon="fas fa-sync-alt" onClick={this.aggiornaIntermediari}>{i18n('ARM_CORE_PRODUCT.AGGIORNA','Aggiorna')}</agui.aButton>

                </div>
                <div className="card-body">

                    <table ref="MyTable" className={AppConstants.CLASS_TABLE} />

                    <agui.ConfirmModalOkCancelV4 show={this.props.showConfirm} >
                        <agui.ConfirmModalOkCancelV4.Header testoTitle={i18n("ARM_CORE_PRODUCT.SHARED.MODIFICA", "Modifica")} onClose={this.closeOnClick} />
                        <agui.ConfirmModalOkCancelV4.Body testoBody="">
                            <div className="row mt-1">
                                <div className="col col-sm-12 col-md-12 col-lg-12">
                                    <agui.ATextInputV4 id={"scontoDiscMin" + this.state.indexIntermediario} type="number"
                                        value={this.state.intermediarioDaModificare && this.state.intermediarioDaModificare.prodottoIntermediario && this.state.intermediarioDaModificare.prodottoIntermediario.scontoDiscMin}
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SCONTO_DISC_MAX','Sconto Discrezionale Min')}
                                        onChange={this.inputChangeHandler}
                                        name="scontoDiscMin"
                                    />
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col col-sm-12 col-md-12 col-lg-12">
                                    <agui.ATextInputV4 id={"scontoDiscMax" + this.state.indexIntermediario} type="number"
                                        value={this.state.intermediarioDaModificare && this.state.intermediarioDaModificare.prodottoIntermediario && this.state.intermediarioDaModificare.prodottoIntermediario.scontoDiscMax}
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SCONTO_DISC_MIN','Sconto Discrezionale Max')}
                                        onChange={this.inputChangeHandler}
                                        name="scontoDiscMax"
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                {opt("APP", "FL_VIEW_CHECKBOX_TAB_INTERMEDIARI", "false") === "true" &&
                                    <div className="col col-sm-1 col-md-1 col-lg-1 mr-5">
                                        <agui.aToggleV4
                                            id={"visDocPolizza" + this.state.indexIntermediario}
                                            name="visDocPolizza"
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.VISDOCPOLIZZA', 'Visualizza Documento Polizza')}
                                            type="NO"
                                            checked={this.state.intermediarioDaModificare && this.state.intermediarioDaModificare.prodottoIntermediario && this.state.intermediarioDaModificare.prodottoIntermediario.visDocPolizza}
                                            value={this.state.intermediarioDaModificare && this.state.intermediarioDaModificare.prodottoIntermediario && this.state.intermediarioDaModificare.prodottoIntermediario.visDocPolizza}
                                            onChange={this.checkBoxChangeHandler}
                                        />
                                    </div>
                                }
                                {opt("APP", "FL_VIEW_CHECKBOX_EMISSIONE", "false") === "true" &&
                                    <div className="col col-sm-1 col-md-1 col-lg-1 ml-5">
                                        <agui.aToggleV4
                                            id={"abilitaEmissione" + this.state.indexIntermediario}
                                            name="abilitaEmissione"
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMED.EMISSIONE', 'Abilita Emissione')}
                                            type="NO"
                                            checked={this.state.intermediarioDaModificare && this.state.intermediarioDaModificare.prodottoIntermediario && this.state.intermediarioDaModificare.prodottoIntermediario.abilitaEmissione}
                                            value={this.state.intermediarioDaModificare && this.state.intermediarioDaModificare.prodottoIntermediario && this.state.intermediarioDaModificare.prodottoIntermediario.abilitaEmissione}
                                            onChange={this.checkBoxChangeHandler}
                                        />
                                    </div>
                                }
                            </div>

                        </agui.ConfirmModalOkCancelV4.Body >
                        <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        testoButtonCancel={i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                            confirmOnClick={this.salvaOnClick} onClose={this.annullaOnClick}>
                        </agui.ConfirmModalOkCancelV4.Footer>
                    </agui.ConfirmModalOkCancelV4>
                </div>

            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        // aggiungiGaranziaOnClick(row) {
        //     return dispatch(GruppoProdottoActions.aggiungiGaranziaOnClick(row));
        // }
        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        aggiornaIntermediari() {
            return dispatch(ProdottoActions.aggiornaIntermediari())
        },

        getProdottoDetails(id) {
            return dispatch(ProdottoActions.getProdottoDetails(id));
        },
    }
};

function mapStateToProps(state) {
    return {
        // rows: state.garanzie.listGaranzie
        showConfirm: state.app.showPopUp,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(IntermediariTable);
